import React from 'react';
import type { CameraStatsSnapshot } from '../services/cloud-stats-collector';

interface Props {
  stats: CameraStatsSnapshot | null;
}

export default function DebugOverlay({ stats }: Props) {
  if (!stats) return null;

  const lossColor = stats.packetLossRate > 0.02 ? 'text-red-400' : stats.packetLossRate > 0.005 ? 'text-amber-400' : 'text-emerald-400';
  const fpsColor = stats.framesPerSecond < 15 ? 'text-red-400' : stats.framesPerSecond < 24 ? 'text-amber-400' : 'text-emerald-400';
  const dropColor = stats.totalFramesDropped > 10 ? 'text-red-400' : stats.totalFramesDropped > 0 ? 'text-amber-400' : 'text-emerald-400';

  return (
    <div className="absolute top-1 left-1 bg-black/80 text-[10px] font-mono text-white px-1.5 py-1 rounded pointer-events-none z-10 leading-relaxed">
      <div className={fpsColor}>FPS: {Math.round(stats.framesPerSecond)}</div>
      <div>Bitrate: {stats.bitrateKbps} kbps</div>
      <div>Res: {stats.frameWidth}×{stats.frameHeight}</div>
      <div>RTT: {stats.rtt}ms | Jitter: {stats.jitter}ms</div>
      <div className={lossColor}>
        Loss: {(stats.packetLossRate * 100).toFixed(2)}% ({stats.totalPacketsLost})
      </div>
      <div>Pkts: {stats.totalPacketsReceived.toLocaleString()}</div>
      <div className={dropColor}>
        Frames ▼: {stats.totalFramesDropped} | Freeze: {stats.freezeCount}
      </div>
      <div>NACK: {stats.nackCount} | PLI: {stats.pliCount}</div>
    </div>
  );
}
